import { closePrintPreview } from '../print/actions'
import { closeTableOfContents } from '../tableOfContents/actions'
import { autoDisplayThumbnails, closeThumbnailsNavigation } from '../thumbnails/actions'
import {
    closeCollaborativeIndexationCreation,
    closeCollaborativeIndexationSummary,
    displayCollaborativeIndexations,
    selectCollaborativeIndexationZone,
} from '../collaborativeIndexations/actions'
import { getCollaborativeIndexationIdFromSearchParams } from '../queryParams/selectors'
import { closeSocialSharing } from '../share/actions'

export const IMAGE_SETTING_ASIDE_NAME = 'imageSetting'
export const ZOOM_ASIDE_NAME = 'zoom'
export const TOGGLE_BOTTOM_ASIDE = 'TOGGLE_BOTTOM_ASIDE'

export const toggleImageSettingsAside = () => ({ type: TOGGLE_BOTTOM_ASIDE, asideName: IMAGE_SETTING_ASIDE_NAME })
export const toggleZoomAside = () => ({ type: TOGGLE_BOTTOM_ASIDE, asideName: ZOOM_ASIDE_NAME })

export function closeAllLeftAsides()
{
    return function closeAllLeftAsides(dispatch)
    {
        dispatch(closeThumbnailsNavigation())
        dispatch(closeTableOfContents())
        dispatch(closePrintPreview())
        dispatch(closeCollaborativeIndexationSummary())
        dispatch(closeCollaborativeIndexationCreation())
        dispatch(closeSocialSharing())
    }
}

export const LOCK_LEFT_ASIDES = 'LOCK_LEFT_ASIDES'
export const lockLeftAside = (lockedBy) => ({ type: LOCK_LEFT_ASIDES, lockedBy })

export const UNLOCK_LEFT_ASIDES = 'UNLOCK_LEFT_ASIDES'
export const unlockLeftAside = () => ({ type: UNLOCK_LEFT_ASIDES })

export function autoDisplayAside()
{
    return function autoDisplayAside(dispatch, getState)
    {
        const collaborativeIndexationUuid = getCollaborativeIndexationIdFromSearchParams(getState())
        if(collaborativeIndexationUuid)
        {
            dispatch(displayCollaborativeIndexations())
            dispatch(selectCollaborativeIndexationZone({uuid: collaborativeIndexationUuid}))

            return
        }

        dispatch(autoDisplayThumbnails())
    }
}
